/*
通信录管理接口
*/
import request from '@/utils/request'
import base from './base';

// 使用基础 API 地址
export const host = base.api_data;

// API 端点定义
const get_department_tree = '/wecom/get_department_tree/';// 获取部门树形结构
const get_department_member_tree = '/wecom/get_department_member_tree/';// 获取部门树形结构
const search_members = '/wecom/search/'; // 添加搜索接口
const get_staff_detail = '/wecom/staff/detail/'; // 获取员工详情接口
const view_contract = '/wecom/DownloadStaffContracts/'; // 新增：查看合同文件接口
const sync_all_data = '/wecom/sync_all_data'; // 添加：同步企业微信数据接口

export default {

    get_department_tree(params) {
        return request.get(`${host}${get_department_tree}`, { params });
    },
    get_department_member_tree(params) {
        return request.get(`${host}${get_department_member_tree}`, { params });
    },
    // 添加搜索方法
    search_members(params) {
        return request.post(`${host}${search_members}`, JSON.stringify(params), { headers: { 'Content-Type': 'application/json' } });
    },
    // 获取员工详情
    get_staff_detail(userid) {
        return request.get(`${host}${get_staff_detail}${userid}/`);
    },
    // 新增：查看合同文件方法
    view_contract(media_id) {
        return request({
            url: `${host}${view_contract}`,
            method: 'get',
            params: { media_id },
            responseType: 'blob' // 重要：指定响应类型为blob
        });
    },
    // 修改同步数据方法
    sync_all_data() {
        return request.get(`${host}${sync_all_data}`);  // 移除 params 参数
    },
};